import React, {FC, useState} from 'react';

import AccountNav from './AccountNav';
import Logo from './Logo';
import {Nav} from './navs';
import SiteNav from './SiteNav';
import TopNav from './TopNav';

import * as styles from './styles.module.scss';

export type NavProps = {
	nav: {
		name: Nav
		active: boolean
		open: () => void
		close: () => void
		flip: () => void
	}
}

const Header: FC = () => {
	const [nav, setNav] = useState<Nav>();
	const navProps = (check: Nav): NavProps => {
		return {
			nav: {
				name: check,
				active: nav === check,
				open: () => setNav(check),
				close: () => setNav(undefined),
				flip: () => setNav(nav === 'site' ? 'account' : 'site'),
			},
		};
	};

	return (
		<div className={styles.wrapper}>
			<div className={styles.header}>
				<SiteNav {...navProps('site')} />
				<Logo />
				<div className={styles.grower} />
				<TopNav {...navProps('site')} />
				<AccountNav {...navProps('account')} />
			</div>
		</div>
	);
};

export default Header;
